<div class="container-training-offer bg-brand-99" [id]="offerta_formativa_id">
    <div *ngIf="block.titolo_generale" class="badge bg-success-40 text-neutral-99 p-3 badge-color text-uppercase">
        <p class="ls-label-medium-semibold m-0" [innerHTML]="block.titolo_generale"></p>
    </div>
    <div *ngIf="block.descrizione_generale" class="px-3 pt-3 pb-0">
        <p class="ls-p text-neutral-30" [innerHTML]="block.descrizione_generale"></p>
    </div>
    <div class="container-training-offer__container-list p-3 border-0 bg-brand-99" *ngIf="block.set_offerte && block.set_offerte.length">
        <ngb-accordion [closeOthers]="true" [destroyOnHide]="true" [animation]="true" #acc="ngbAccordion"
            class="bg-brand-99 border-0">
            <ngb-panel *ngFor="let item of block.set_offerte" [id]="'accordion' + item.id"
                cardClass="custom-accordion bg-brand-99">
                <ng-template ngbPanelHeader let-opened="opened" class="bg-brand-99">
                    <div class="container-btn bg-brand-99" [class.collapsed]="!opened">
                        <button
                            class="w-100 d-flex align-items-center justify-content-between text-left border-0 rounded-0 bg-brand-99 p-3"
                            ngbPanelToggle>
                            <span class="bg-brand-99 ls-label-medium-semibold text-brand-10 text-uppercase" style="padding: 0 0.5rem;"
                                [innerHTML]="item.titolo_elemento_a_comparsa"></span>
                            <div class="pe-3">
                                <img loading="lazy" *ngIf="!acc.isExpanded('accordion' + item.id)" src="./assets/images/open_training_offer.svg" alt="icon open | LUMSA">
                                <img loading="lazy" *ngIf="acc.isExpanded('accordion' + item.id)" src="./assets/images/close_training_offer.svg" alt="icon close | LUMSA">
                            </div>
                        </button>
                    </div>
                </ng-template>
                <ng-template ngbPanelContent class="bg-brand-99">
                    <div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" class="text-brand-10 ls-label-small-semibold text-uppercase">
                                        {{"BLOCK.SAMPLE_TRAINING_OFFER.TEACHING" | translate}}
                                    </th>
                                    <th scope="col" class="text-brand-10 ls-label-small-semibold text-uppercase">
                                        {{"BLOCK.SAMPLE_TRAINING_OFFER.LANGUAGE" | translate}}
                                    </th>
                                    <th scope="col" class="text-brand-10 ls-label-small-semibold text-uppercase">
                                        {{"BLOCK.SAMPLE_TRAINING_OFFER.TYPOLOGY" | translate}}
                                    </th>
                                    <th scope="col" class="text-brand-10 ls-label-small-semibold text-uppercase">
                                        {{"BLOCK.SAMPLE_TRAINING_OFFER.SEMESTER" | translate}}
                                    </th>
                                    <th scope="col" class="text-brand-10 ls-label-small-semibold text-uppercase">
                                        {{"BLOCK.SAMPLE_TRAINING_OFFER.SSD" | translate}}
                                    </th>
                                    <th scope="col" class="text-brand-10 ls-label-small-semibold text-uppercase">
                                        {{"BLOCK.SAMPLE_TRAINING_OFFER.CFU" | translate}}
                                    </th>
                                    <th scope="col" class="text-brand-10 ls-label-small-semibold text-uppercase">
                                        {{"BLOCK.SAMPLE_TRAINING_OFFER.HOUR" | translate}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="item.elenco_insegnamenti">
                                    <ng-container *ngFor="let subItem of item.elenco_insegnamenti; let idx = index;">
                                        <tr [ngClass]="{'border-bottom-tr': !subItem.insegnamento_alternativo}">
                                            <td *ngIf="subItem.titolo_insegnamento && subItem.link_insegnamento && retriveLink(subItem.link_insegnamento).isExternal"
                                                class="text-brand-40 ls-p cursor-pointer">
                                                <a [href]="retriveLink(subItem.link_insegnamento).link" target="_blank">
                                                    <u [innerHTML]="subItem.titolo_insegnamento | safeHtml"></u>
                                                </a>
                                            </td>
                                            <td *ngIf="subItem.titolo_insegnamento && subItem.link_insegnamento && !retriveLink(subItem.link_insegnamento).isExternal"
                                                class="text-brand-40 ls-p cursor-pointer">
                                                <a [routerLink]="navigationService.splitUrlRouterLink(retriveLink(subItem.link_insegnamento).link).path" [queryParams]="navigationService.splitUrlRouterLink(retriveLink(subItem.link_insegnamento).link).queryParams">
                                                    <u [innerHTML]="subItem.titolo_insegnamento | safeHtml"></u>
                                                </a>
                                            </td>
                                            <td *ngIf="subItem.titolo_insegnamento && !subItem.link_insegnamento"
                                                class="text-brand-40 ls-p">
                                                <u class="no-underline" [innerHTML]="subItem.titolo_insegnamento | safeHtml"></u>
                                            </td>
                                            <td class="ls-p" [innerHTML]="subItem.lingua_insegnamento"></td>
                                            <td [innerHTML]="subItem.tipologia_insegnamento"></td>
                                            <td class="ls-p" [innerHTML]="subItem.semestre"></td>
                                            <td class="ls-p" [innerHTML]="subItem.ssd"></td>
                                            <td class="ls-p" [innerHTML]="subItem.crediti"></td>
                                            <td class="ls-p" [innerHTML]="subItem.ore_insegnamento"></td>
                                        </tr>
                                        <p class="m-0 text-neutral-30 ls-label-medium" *ngIf="subItem.insegnamento_alternativo">{{"BLOCK.SAMPLE_TRAINING_OFFER.OR" | translate}}</p>
                                    </ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>
    </div>
</div>